import React from 'react'
// import { History } from 'history'
// import { useHistory } from 'react-router-dom'
import image01 from '../../assets/products/img-1-md.jpg'
import image02 from '../../assets/products/img-2-md.jpg'
import image03 from '../../assets/products/img-3-md.jpg'
import 'react-animated-slider/build/horizontal.css';
import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext, ImageWithZoom } from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';
import './Services.scss'
type Props = {
}

interface MyCompProps {
	interval: number
}

const Services: React.FC<Props> = props => {

  return (
    <div className="col m-auto py-3 services">
        <div className="row">
            <div className="col-12 col-lg-6 mx-auto ">
            <CarouselProvider
                visibleSlides={1}
                totalSlides={3}
                step={1}
                naturalSlideWidth={800}
                naturalSlideHeight={600}
                hasMasterSpinner
            >
                <Slider>
                    <Slide index={0}><ImageWithZoom src={image01}/></Slide>
                    <Slide index={1}><ImageWithZoom src={image02}/></Slide>
                    <Slide index={2}><ImageWithZoom src={image03}/></Slide>
                </Slider>
                <ButtonBack>Back</ButtonBack>
                <ButtonNext>Next</ButtonNext>
            </CarouselProvider>
            </div>

        </div>
    </div>
  )
}
export default Services
